module.exports = __webpack_public_path__ + "static/Milti-Column-Sorting-17d28e801d08043a42cf13dc64de6108.png";